import React, { useState, useRef } from "react";
import { FormBox } from "./FormBox"
import { MaterialTableBox } from "./materialTableBox"
import { ItemTableBox } from "./itemTableBox"
import { FixedBottom } from "./FixedBottom"
import { MaterialModal } from "./materialModal"
import { ItemModal } from "./itemModal"
import useNavModel, { RouterParamType } from "@/model/navModel";
import { IYhFormRef } from "@/components/YhFormBox/Types";
import { useRepairTemplateDetailsModel } from "./repairTemplateDetailsModels";
import { HistoryModel } from "@/views/historyModel";
import { ConsumeHistoryModel } from "@/views/commonModule/consumeHistoryModel"
import { RepairHistoryModel } from "@/views/commonModule/repairHistoryModel"
import useGlobalModel from "@/model/globalModel";
import { TabsBox } from "./TabsBox";



export const RepairTemplateDetails = () => {
    const { getSelectedNavState } = useNavModel();
    const [detailsInfo] = useState<RouterParamType>(getSelectedNavState() as RouterParamType);

    const IFormRef = useRef<IYhFormRef>();
    const {
        historyRow,
        historyVisible, setHistoryVisible,
        consumeHistoryModel,
        consumeHistoryVisible, setConsumeHistoryVisible,
        repairHistoryVisible, setRepairHistoryVisible,
        repairHistoryModel, setRepairHistoryModel
    } = useRepairTemplateDetailsModel()
    const { user: { roles } } = useGlobalModel();

    return (
        <>
            <FormBox {...detailsInfo} IFormRef={IFormRef} />
            {/* <FixedBottom {...detailsInfo} /> */}
            <HistoryModel
                visible={historyVisible}
                materialCode={historyRow.materialCode as string}
                materialName={historyRow.materialName as string}
                onCancel={() => setHistoryVisible(false)}
            />
            <TabsBox {...detailsInfo} IFormRef={IFormRef} />
            <MaterialModal {...detailsInfo} />
            <ItemModal {...detailsInfo} />
            <ConsumeHistoryModel
                visible={consumeHistoryVisible}
                name={consumeHistoryModel.customerName}
                onCancel={() => setConsumeHistoryVisible(false)}
            />
            <RepairHistoryModel
                visible={repairHistoryVisible}
                licensePlate={repairHistoryModel.licensePlate}
                onCancel={() => setRepairHistoryVisible(false)}
            />
        </>
    )
}